import CourseRunDetails from "@/models/CourseRunDetails";

function parseTimestamp(value) {
    if (!value) {
        return null;
    }

    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
}

export default class CompoundCoursePart {
    constructor(raw = {}) {
        this.order = raw.order;
        this.canStart = raw.canStart;
        this.name = raw.name;
        this.courseRunId = raw.courseRunId;
        this.state = raw.state;
        this.partId = raw.partId;
        this.courseRunPartDetails = new CourseRunDetails(raw.courseRunPartDetails);
        this.webLink = raw.webLink;
        this.stepType = raw.stepType;
    }

    get isStartedButNotDone() {
        return this.courseRunPartDetails.startDate != null && this.courseRunPartDetails.successDate == null;
    }

    get isDoneSuccess() {
        return this.courseRunPartDetails.successDate != null;
    }

    get waitsForApproval() {
        return this.isStartedButNotDone && !this.isDoneSuccess && !this.isDoneError && this.courseRunPartDetails.certificateLink != null;
    }

    get isDoneError() {
        return this.courseRunPartDetails.failureDate != null;
    }

    get lastSyncTimestamp() {
        return parseTimestamp(this.courseRunPartDetails.lastSyncDate);
    }

    get lastSyncLabel() {
        return this.lastSyncTimestamp == null ? "Noch nie" : new Date(this.lastSyncTimestamp).toLocaleString("de-DE");
    }

    get hasPersistedState() {
        return typeof this.state === "string" && this.state.length > 0;
    }

    get hasSyncRisk() {
        if (!this.isStartedButNotDone) {
            return false;
        }

        return Boolean(this.courseRunPartDetails.syncIssueReason);
    }

    get syncRiskLabel() {
        if (!this.isStartedButNotDone) {
            return "Kein aktiver Kursteil";
        }

        return this.hasSyncRisk ? this.courseRunPartDetails.syncIssueLabel : "Kein Sync-Problem";
    }

    stateAsJson() {
        return JSON.parse(this.state).cmi;
    }

    get courseRunUrl() {
        return "https://lms.behrendtonline.com/behrendt" + this.webLink;
    }

    get isStepTypeStorage() {
        return this.stepType === "STORAGE";
    }

    get isStepTypeQuestions() {
        return this.stepType === "QUESTIONS";
    }

    get isStepTypeShippersDeclaration() {
        return this.stepType === "SHIPPERS_DECLARATION";
    }

    get isStepTypeDeclaredGoods() {
        return this.stepType === "DECLARED_GOODS";
    }

}
